module.exports = __webpack_public_path__ + "img/0a7df3c5510e8fa363b8fbbbf39f5cb0.ba44f1c9.png";